jQuery(document).ready(function() {

  var posttype = jQuery('#post_type').val();
  if ( posttype == 'cp_evenemang' ) {
      // ------( Evenemang : form validation )--------------------------//
      jQuery("input[type=text], textarea").focusin( function( event ) {
           event.preventDefault();
           var errDIV = '#err_' + jQuery(this).attr('name');
           jQuery( errDIV ).remove();
      });

      jQuery( "form#post #publish" ).click( function ( e ) {
              var count_err   = 0;
              var regex_email = /^[\w\-\.\+]+\@[a-zA-Z0-9\.\-]+\.[a-zA-z0-9]{2,4}$/; // Valid epost@server.dom
              var regex_time  = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/; // Valid hh:mm
              var regex_date  = /^(\d{4})(\/|-)(\d{1,2})(\/|-)(\d{1,2})$/; // valid yyyy-mm-dd

              if ( !regex_time.test( jQuery("input[name=cp_events_starttime]").val() ) ) {
                  count_err++;
                  add_error_div( '#cf-datetime', 'Starttid', 'cp_events_starttime' );
              }
              if ( !regex_time.test( jQuery("input[name=cp_events_endtime]").val() ) ) {
                  count_err++;
                  add_error_div( '#cf-datetime', 'Sluttid', 'cp_events_endtime' );
              }
              if ( !regex_date.test( jQuery("input[name=cp_events_startdate]").val() ) ) {
                  count_err++;
                  add_error_div( '#cf-datetime', 'Startdatum', 'cp_events_startdate' );
              }
              if ( !regex_date.test( jQuery("input[name=cp_events_enddate]").val() ) ) {
                  count_err++;
                  add_error_div( '#cf-datetime', 'Slutdatum', 'cp_events_enddate' );
              }
              if (jQuery.trim( jQuery("input[name=cp_adress]").val() ).length === 0) {
                  count_err++;
                  add_error_div( '#cf_place', 'Adress', 'cp_adress' );
              }
              if (jQuery.trim( jQuery("input[name=cp_plats]").val() ).length === 0) {
                  count_err++;
                  add_error_div( '#cf_place', 'Platsens namn', 'cp_plats' );
              }
              if (jQuery.trim( jQuery("input[name=cp_kostnad]").val() ).length === 0) {
                  count_err++;
                  add_error_div( '#cf_cost', 'Kostnad', 'cp_kostnad' );
              }
              if ( !regex_email.test( jQuery("input[name=cp_epost]").val() ) ) {
                  count_err++;
                  add_error_div( '#cf_contact', 'E-postadress', 'cp_epost' );
              }
              if (jQuery.trim( jQuery("input[name=cp_kontaktperson]").val() ).length === 0) {
                  count_err++;
                  add_error_div( '#cf_contact', 'Kontaktperson', 'cp_kontaktperson' );
              }
              if ( count_err >= 1 ) {
                  e.preventDefault();
                  if ( jQuery('#err_msg').length) { jQuery('#err_msg').remove(); }
                  var msg_err = '<div id="err_msg" class="acf-notice -error acf-error-message -dismiss"><p>Validering misslyckades. '+ count_err +' fält kräver din uppmärksamhet</p><a id="err_msg_close" href="#" class="acf-notice-dismiss acf-icon -cancel small"></a></div>';
                  jQuery('form#post').prepend ( msg_err );
              } else {
                  return;
              }
              jQuery('#err_msg_close').click( function () { jQuery('#err_msg').remove(); });
              function add_error_div( todivID, fErr, fSource ) {
                  var divID = 'err_' + fSource;
                  var html  = '<div id="' + divID + '" class="acf-notice -error acf-error-message"><p>' + fErr + ' värde är obligatorisk</p></div>';
                  if ( !jQuery('#'+divID ).length ) { jQuery( todivID ).prepend( html ); }
              }
      });
      // ------( Evenemang : Instructors fields control )------------------//
        var max_fields      = 10; //maximum input boxes allowed
        var wrapper         = jQuery(".input_fields_wrap"); //Fields wrapper
        var add_button      = jQuery(".add_field_button"); //Add button ID
        var x               = 1; //initlal text box count

        jQuery(add_button).click(function(e){ //on add input button click
            e.preventDefault();
            if(x < max_fields){ //max input box allowed
                x++; //text box increment
                jQuery(wrapper).append('<div class="rad"><label>Namn:</label><input type="text" name="cp_instrukt[]" class="cp-instrukt" maxlength="50"><a href="#" class="acf-button button button-primary remove_field">- Ta bort</a></div>');//add input box
            }
        });
        jQuery(wrapper).on("click",".remove_field", function(e){ //user click on remove text
            e.preventDefault();
            jQuery(this).parent('div').remove(); x--;
        });
        // ------( Evenemang : Media files control )-----------------------//
            var frame = wp.media({
              title: 'Välj en pdf-fil',
              button: { text: 'Använd' },
              multiple: false
            });
            jQuery("#jjk_upload_inbjudan").click(function(e) {
                if (jQuery("#jjk_upload_inbjudan").hasClass('btn-delete')) {
                    jQuery("input[name=cp_inbjudan]").val('');
                    jQuery("#jjk_upload_inbjudan").html('Lägg till fil');
                    jQuery("#jjk_upload_inbjudan").removeClass('btn-delete');
                    jQuery("input[name=cp_dok_ett_rubrik]").val('');
                } else {
                    e.preventDefault();
                    frame.open();
                }
            });
            frame.on('select', function(){
              var attachment = frame.state().get('selection').first().toJSON();
              jQuery("input[name=cp_inbjudan]").val(attachment.url);
              jQuery("#jjk_upload_inbjudan").html('Ta bort');
              jQuery("#jjk_upload_inbjudan").addClass('btn-delete');

            });

            var frame2 = wp.media({
              title: 'Välj en pdf-fil',
              button: { text: 'Använd' },
              multiple: false
            });
            jQuery("#jjk_upload_anmalan").click(function(e) {
                if (jQuery("#jjk_upload_anmalan").hasClass('btn-delete')) {
                    jQuery("input[name=cp_anmalningsblankett]").val('');
                    jQuery("#jjk_upload_anmalan").html('Lägg till fil');
                    jQuery("#jjk_upload_anmalan").removeClass('btn-delete');
                    jQuery("input[name=cp_dok_tva_rubrik]").val('');
                } else {
                    e.preventDefault();
                    frame2.open();
                }
            });
            frame2.on('select', function(){
                var attachment2 = frame2.state().get('selection').first().toJSON();
                jQuery("input[name=cp_anmalningsblankett]").val(attachment2.url);
                jQuery("#jjk_upload_anmalan").html('Ta bort');
                jQuery("#jjk_upload_anmalan").addClass('btn-delete');
            });

            var frame3 = wp.media({
              title: 'Välj en pdf-fil',
              button: { text: 'Använd' },
              multiple: false
            });
            jQuery("#jjk_upload_docextra").click(function(e) {
                if (jQuery("#jjk_upload_docextra").hasClass('btn-delete')) {
                    jQuery("input[name=cp_docextra]").val('');
                    jQuery("#jjk_upload_docextra").html('Lägg till fil');
                    jQuery("#jjk_upload_docextra").removeClass('btn-delete');
                    jQuery("input[name=cp_dok_tre_rubrik]").val('');
                } else {
                    e.preventDefault();
                    frame3.open();
                }
            });
            frame3.on('select', function(){
                var attachment3 = frame3.state().get('selection').first().toJSON();
                jQuery("input[name=cp_docextra]").val(attachment3.url);
                jQuery("#jjk_upload_docextra").html('Ta bort');
                jQuery("#jjk_upload_docextra").addClass('btn-delete');
            });

            jQuery(".cp-date").datepicker({
                  closeText: 'Stäng',
                	prevText: '< Föregående',
                	nextText: 'Nästa >',
                	currentText: 'Nu',
                	monthNames: ['Januari','Februari','Mars','April','Maj','Juni','Juli','Augusti','September','Oktober','November','December'],
                  monthNamesShort: ['Jan','Feb','Mar','Apr','Maj','Jun','Jul','Aug','Sep','Okt','Nov','Dec'],
                	dayNamesShort: ['Sön','Mån','Tis','Ons','Tor','Fre','Lör'],
                	dayNames: ['Söndag','Måndag','Tisdag','Onsdag','Torsdag','Fredag','Lördag'],
                	dayNamesMin: ['Sö','Må','Ti','On','To','Fr','Lö'],
                	weekHeader: 'Не',
                	dateFormat: 'yy-mm-dd',
                	firstDay: 1,
                	isRTL: false,
                	showMonthAfterYear: false,
                	yearSuffix: '',
                  numberOfMonths: 2,
                  showOn: 'button',
                  buttonImage: '../wp-content/themes/ju-jutsukai/assets/css/images/icon-datepicker-grey.png',
                  buttonImageOnly: true
                });
            jQuery(".cp-time").timepicker({
                controlType: 'slider',
                timeOnlyTitle: 'Välj klockslag',
                timeText: 'Tid',
                hourText: 'Timma',
                minuteText: 'Minut',
                secondText: 'Sekund',
                millisecText: 'Millisekund',
                timezoneText: 'Tidszon',
                currentText: 'Nu',
                closeText: 'Stäng',
                timeFormat: 'HH:mm',
                amNames: ['AM', 'A'],
                pmNames: ['PM', 'P'],
                minTime: '08:00',
                maxTime: '22:00',
                isRTL: false,
                oneLine: true,
                stepHour: 1,
                stepMinute: 10
              });
   } // if cp_evenemang
}); // jQuery(document).ready(function()
